export default __webpack_public_path__ + "static/media/IBMFolder.be7b4584.svg";